const { getCookie } = require('./browserData');
const { COOKIES } = require('../constants');

const getDefaultPoliticalIdWithLatLong = require('../apis/getDefaultPoliticalIdWithLatLong');

const getPoliticalIdWithLatLong = (tenantId, catalystBaseUrl) => {
  const politicalId = getCookie(COOKIES.POLITICAL_ID);
  const addresslineCookie = getCookie(COOKIES.ADDRESS_LINES);
  const addressLineArray = (addresslineCookie && addresslineCookie.split('*')) || [];
  if (politicalId && addressLineArray[3] && addressLineArray[4]) {
    return { politicalId, lat: addressLineArray[3], long: addressLineArray[4] };
  }
  return getDefaultPoliticalIdWithLatLong(tenantId, catalystBaseUrl);
};

module.exports = getPoliticalIdWithLatLong;
